import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'

import { useRemoveAlerts } from '../../hooks'


export default function IconRemoveAlerts({ idLineSelected, alertType }) {

    const { showToaster } = useToaster()
    const { removeAlerts } = useRemoveAlerts()

	const handleClick = () => {
        showToaster.confirm(`Are you sure to remove selected alerts?`, {
            onSuccess: () => {
                removeAlerts(idLineSelected, alertType)
            },
            onCancel: () => {
                showToaster.error('Cancelled!')
            }
        })
        
	}

	return <IconButtonSeeker icon="trash-alt" iconType="fontAwesome" title="Remove alerts" onClick={handleClick} />
}